import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
    const { register } = useAuth();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await register(form.name, form.email, form.password);
            navigate("/account");
        } catch (e) {
            setErr(formatApiError(e.response?.data?.detail) || e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page" data-testid="register-page">
            <div className="eyebrow" style={{ marginBottom: 12 }}>Join RAX</div>
            <h1>Create your account.</h1>
            <p>For orders, consignments, and first look at each drop.</p>
            <form className="auth-form" onSubmit={onSubmit} data-testid="register-form">
                <div className="field">
                    <label className="label" htmlFor="rg-name">Name</label>
                    <input
                        id="rg-name"
                        className="input"
                        required
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        data-testid="register-name"
                    />
                </div>
                <div className="field">
                    <label className="label" htmlFor="rg-email">Email</label>
                    <input
                        id="rg-email"
                        type="email"
                        className="input"
                        required
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        data-testid="register-email"
                    />
                </div>
                <div className="field">
                    <label className="label" htmlFor="rg-pass">Password</label>
                    <input
                        id="rg-pass"
                        type="password"
                        className="input"
                        required
                        minLength={6}
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        data-testid="register-password"
                    />
                </div>
                {err && <div className="form-error" data-testid="register-error">{err}</div>}
                <button className="btn" type="submit" disabled={loading} data-testid="register-submit">
                    {loading ? "Creating…" : "Create Account"}
                </button>
                <div className="alt">
                    Already have one?{" "}
                    <Link to="/login" className="link-underline">Sign in</Link>
                </div>
            </form>
        </div>
    );
}
